/* RUZA Celestial – animations. Optionnel : le site fonctionne sans ce fichier. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const store = { get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} } };

  /* ---------- Intro (une fois par visite) ---------- */
  function intro() {
    const el = $('[data-fx-intro]');
    if (!el) return;
    if (reduce || store.get('ruza-intro')) { el.remove(); return; }
    store.set('ruza-intro', '1');
    document.body.classList.add('is-locked');
    const done = () => {
      el.classList.add('is-done');
      document.body.classList.remove('is-locked');
      setTimeout(() => el.remove(), 750);
    };
    setTimeout(done, 1500);
    el.addEventListener('click', done, { once: true });
  }

  /* ---------- Découpe des titres en mots ---------- */
  function splitWords(el) {
    if (el.dataset.fxSplit || el.children.length) return;
    const words = el.textContent.trim().split(/\s+/);
    el.setAttribute('aria-label', el.textContent.trim());
    el.innerHTML = words.map((w, i) => `<span class="fx-word" aria-hidden="true"><span style="--w:${i}">${w.replace(/</g, '&lt;')}</span></span>`).join(' ');
    el.dataset.fxSplit = '1';
  }

  /* ---------- Apparitions au défilement ---------- */
  const REVEAL = [
    ['.section__head, .collection__head, .faq__head, .rich-text__inner > *, .newsletter__inner > *, .contact__intro > *, .page-content__inner > *', ''],
    ['.grid > li', 'stagger'],
    ['.features__item', 'stagger'],
    ['.trust__item', 'stagger'],
    ['.split__media', 'rv--clip'],
    ['.split__text > *', 'stagger'],
    ['.accordion__item', 'stagger'],
    ['.product__info-inner > *', 'stagger'],
    ['.gallery__item', 'rv--zoom'],
    ['.footer__inner > *', 'stagger'],
    ['.contact__form-wrap, .cart__aside, .table-wrap', 'rv--zoom'],
    ['.vbreak__text > *', 'stagger'],
    ['.empty > *', 'stagger']
  ];
  function reveal() {
    if (reduce) return;
    $$('.h1, .h2, .vbreak__title').forEach(splitWords);
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    REVEAL.forEach(([sel, mode]) => {
      const groups = new Map();
      $$(sel).forEach(el => {
        if (el.closest('.drawer') || el.classList.contains('rv')) return;
        const parent = el.parentElement;
        const i = groups.get(parent) || 0; groups.set(parent, i + 1);
        el.classList.add('rv');
        if (mode && mode !== 'stagger') el.classList.add(mode);
        el.style.setProperty('--i', mode === 'stagger' || !mode ? Math.min(i, 8) : 0);
        io.observe(el);
      });
    });
    $$('.fx-word').forEach(w => { const h = w.closest('.h1, .h2, .vbreak__title'); if (h && !h.classList.contains('rv')) { h.classList.add('fx-split-host'); io.observe(h); } });
  }

  /* ---------- Compteurs (300 GSM, 100 %) ---------- */
  function counters() {
    if (reduce) return;
    const io = new IntersectionObserver((entries) => entries.forEach(e => {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      const el = e.target, m = el.textContent.match(/^(\D*)(\d+)(.*)$/);
      if (!m) return;
      const end = parseInt(m[2], 10), t0 = performance.now(), dur = 1400;
      const tick = (now) => {
        const p = Math.min(1, (now - t0) / dur), v = Math.round(end * (1 - Math.pow(1 - p, 3)));
        el.textContent = m[1] + v + m[3];
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }), { threshold: 0.6 });
    $$('.features__figure').forEach(el => { if (/^\D*\d+/.test(el.textContent)) io.observe(el); });
  }

  /* ---------- Défilement : progression, parallaxe, boutons flottants ---------- */
  function scrollFx() {
    const bar = $('[data-fx-progress]');
    const top = $('[data-fx-top]');
    const ring = $('[data-fx-top-ring]');
    const badge = $('[data-fx-badge]');
    const heroMedia = $('[data-hero-media]');
    const heroContent = $('[data-hero-content]');
    const sticky = $('[data-sticky-buy]');
    let ticking = false;
    const update = () => {
      ticking = false;
      const y = window.scrollY, max = document.documentElement.scrollHeight - innerHeight;
      const p = max > 0 ? y / max : 0;
      if (bar) bar.style.transform = `scaleX(${p})`;
      if (ring) ring.style.strokeDashoffset = String(132 - 132 * p);
      if (top) top.classList.toggle('is-hidden-fx', y < innerHeight * 0.8);
      if (badge) badge.classList.toggle('is-hidden-fx', y < 200);
      document.body.classList.toggle('has-sticky-buy', !!(sticky && sticky.classList.contains('is-visible')));
      if (!reduce && heroMedia && y < innerHeight * 1.2 && heroMedia.closest('.hero--video-text')) {
        heroMedia.style.transform = `scale(${1 + y * 0.00025})`;
        heroMedia.style.filter = `brightness(${Math.max(0.35, 1 - y / innerHeight)})`;
      } else if (!reduce && heroMedia && y < innerHeight * 1.2) {
        heroMedia.style.transform = `translate3d(0, ${y * 0.35}px, 0) scale(${1 + y * 0.0003})`;
        if (heroContent) { heroContent.style.transform = `translate3d(0, ${y * -0.12}px, 0)`; heroContent.style.opacity = String(Math.max(0, 1 - y / (innerHeight * 0.7))); }
      }
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
    if (top) top.addEventListener('click', () => window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }));
    const next = $('[data-scroll-next]');
    if (next) next.addEventListener('click', (e) => {
      e.preventDefault();
      const hero = next.closest('.shopify-section') || next.closest('[data-hero]');
      const target = hero && hero.nextElementSibling;
      if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  /* ---------- Vidéos qui démarrent quand elles sont visibles ---------- */
  function lazyVideos() {
    const vids = $$('[data-lazy-video]');
    if (!vids.length || reduce) return;
    const io = new IntersectionObserver(entries => entries.forEach(e => {
      const v = e.target;
      if (e.isIntersecting && v.offsetParent !== null) { v.preload = 'auto'; const p = v.play(); if (p && p.then) p.then(() => v.classList.add('is-playing')).catch(() => {}); }
      else v.pause();
    }), { threshold: 0.2 });
    vids.forEach(v => io.observe(v));
  }

  /* ---------- Cartes 3D, boutons magnétiques, ondulation ---------- */
  function pointerFx() {
    if (reduce) return;
    if (finePointer) {
      document.addEventListener('pointermove', (e) => {
        const card = e.target.closest('.card__link');
        if (card) {
          const r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          card.style.transform = `perspective(900px) rotateY(${(x - 0.5) * 10}deg) rotateX(${(0.5 - y) * 10}deg) translateZ(0)`;
          const media = $('.card__media', card);
          if (media) { media.style.setProperty('--gx', `${x * 100}%`); media.style.setProperty('--gy', `${y * 100}%`); }
        }
        const btn = e.target.closest('.button, .fx-badge, .social__link');
        if (btn) {
          const r = btn.getBoundingClientRect();
          btn.style.translate = `${(e.clientX - r.left - r.width / 2) * 0.18}px ${(e.clientY - r.top - r.height / 2) * 0.28}px`;
        }
      }, { passive: true });
      document.addEventListener('pointerout', (e) => {
        const card = e.target.closest('.card__link');
        if (card && !card.contains(e.relatedTarget)) card.style.transform = '';
        const btn = e.target.closest('.button, .fx-badge, .social__link');
        if (btn && !btn.contains(e.relatedTarget)) btn.style.translate = '';
      });
    }
    document.addEventListener('pointerdown', (e) => {
      const btn = e.target.closest('.button, .variant-picker__pill, .qty__btn');
      if (!btn || btn.disabled) return;
      const r = btn.getBoundingClientRect(), d = Math.max(r.width, r.height);
      const s = document.createElement('span');
      s.className = 'fx-ripple';
      s.style.cssText = `width:${d}px;height:${d}px;left:${e.clientX - r.left - d / 2}px;top:${e.clientY - r.top - d / 2}px`;
      if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
      btn.style.overflow = 'hidden';
      btn.appendChild(s);
      setTimeout(() => s.remove(), 700);
      if (navigator.vibrate && e.pointerType === 'touch' && btn.matches('.buy__add, [data-sticky-add]')) navigator.vibrate(12);
    });
  }

  /* ---------- Étincelles ---------- */
  const SPARK_COLORS = ['#ffffff', '#DCE9FB', '#9BBBE8', '#6A92D2'];
  function burst(x, y, n = 18, spread = 120) {
    if (reduce) return;
    for (let i = 0; i < n; i++) {
      const s = document.createElement('span');
      s.className = 'fx-spark';
      s.style.left = `${x - 7}px`; s.style.top = `${y - 7}px`;
      s.style.color = SPARK_COLORS[i % SPARK_COLORS.length];
      document.body.appendChild(s);
      const a = Math.random() * Math.PI * 2, d = spread * (0.4 + Math.random() * 0.8);
      s.animate([
        { transform: 'translate(0,0) scale(0) rotate(0deg)', opacity: 1 },
        { transform: `translate(${Math.cos(a) * d}px, ${Math.sin(a) * d}px) scale(${0.6 + Math.random()}) rotate(${Math.random() * 180}deg)`, opacity: 1, offset: 0.6 },
        { transform: `translate(${Math.cos(a) * d * 1.2}px, ${Math.sin(a) * d * 1.2 + 30}px) scale(0) rotate(220deg)`, opacity: 0 }
      ], { duration: 800 + Math.random() * 500, easing: 'cubic-bezier(.2,.7,.2,1)' }).onfinish = () => s.remove();
    }
  }

  /* ---------- Ajout au panier : l'image vole vers le panier ---------- */
  function toast(text) {
    const t = $('[data-fx-toast]');
    if (!t) return;
    $('[data-fx-toast-text]', t).textContent = text;
    t.hidden = false;
    requestAnimationFrame(() => t.classList.add('is-visible'));
    clearTimeout(toast._t);
    toast._t = setTimeout(() => { t.classList.remove('is-visible'); setTimeout(() => { t.hidden = true; }, 400); }, 2400);
  }
  document.addEventListener('ruza:cart-added', (e) => {
    const cart = $('.header__cart');
    const img = e.detail && e.detail.image;
    const btn = e.detail && e.detail.button;
    toast('Ajouté au panier ✦');
    if (btn) { const r = btn.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height / 2, 22, 140); }
    if (!cart) return;
    const c = cart.getBoundingClientRect();
    const land = () => {
      cart.classList.remove('is-bump'); void cart.offsetWidth; cart.classList.add('is-bump');
      const count = $('[data-cart-count]');
      if (count) { count.classList.remove('is-pop'); void count.offsetWidth; count.classList.add('is-pop'); }
      burst(c.left + c.width / 2, c.top + c.height / 2, 12, 60);
    };
    if (reduce || !img) { land(); return; }
    const r = img.getBoundingClientRect();
    const fly = img.cloneNode();
    fly.removeAttribute('srcset'); fly.removeAttribute('sizes');
    fly.className = 'fx-fly';
    Object.assign(fly.style, { left: `${r.left}px`, top: `${r.top}px`, width: `${r.width}px`, height: `${r.height}px` });
    document.body.appendChild(fly);
    const dx = c.left + c.width / 2 - (r.left + r.width / 2), dy = c.top + c.height / 2 - (r.top + r.height / 2);
    fly.animate([
      { transform: 'translate(0,0) scale(1) rotate(0)', opacity: 1, borderRadius: '8px' },
      { transform: `translate(${dx * 0.5}px, ${dy * 0.5 - 120}px) scale(.45) rotate(-12deg)`, opacity: 1, offset: 0.55 },
      { transform: `translate(${dx}px, ${dy}px) scale(.06) rotate(20deg)`, opacity: 0.2, borderRadius: '50%' }
    ], { duration: 750, easing: 'cubic-bezier(.5,0,.3,1)' }).onfinish = () => { fly.remove(); land(); };
  });

  /* ---------- Traînée d'étoiles derrière la souris ---------- */
  function cursorTrail() {
    const cv = $('[data-fx-cursor]');
    if (!cv || reduce || !finePointer) { if (cv) cv.remove(); return; }
    const ctx = cv.getContext('2d');
    let w, h, dpr = Math.min(2, window.devicePixelRatio || 1);
    const resize = () => { w = innerWidth; h = innerHeight; cv.width = w * dpr; cv.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
    resize(); window.addEventListener('resize', resize);
    const parts = []; let lx = 0, ly = 0, running = false;
    window.addEventListener('pointermove', (e) => {
      const d = Math.hypot(e.clientX - lx, e.clientY - ly);
      if (d < 14) return;
      lx = e.clientX; ly = e.clientY;
      parts.push({ x: lx, y: ly, vx: (Math.random() - .5) * .6, vy: Math.random() * .6 + .2, life: 1, s: 2 + Math.random() * 3.5, c: SPARK_COLORS[(Math.random() * 4) | 0] });
      if (parts.length > 60) parts.shift();
      if (!running) { running = true; requestAnimationFrame(loop); }
    }, { passive: true });
    function star(x, y, s, a, c) {
      ctx.globalAlpha = a; ctx.fillStyle = c;
      ctx.beginPath();
      ctx.moveTo(x, y - s); ctx.quadraticCurveTo(x, y, x + s, y); ctx.quadraticCurveTo(x, y, x, y + s);
      ctx.quadraticCurveTo(x, y, x - s, y); ctx.quadraticCurveTo(x, y, x, y - s); ctx.fill();
    }
    function loop() {
      ctx.clearRect(0, 0, w, h);
      for (let i = parts.length - 1; i >= 0; i--) {
        const p = parts[i];
        p.life -= 0.022; p.x += p.vx; p.y += p.vy;
        if (p.life <= 0) { parts.splice(i, 1); continue; }
        star(p.x, p.y, p.s * p.life + 1, p.life, p.c);
      }
      ctx.globalAlpha = 1;
      if (parts.length) requestAnimationFrame(loop); else { running = false; ctx.clearRect(0, 0, w, h); }
    }
  }

  /* ---------- Bandeau d'annonce qui tourne (mobile) ---------- */
  function announcement() {
    const items = $$('.announcement__item');
    if (items.length < 2 || reduce) return;
    const mq = window.matchMedia('(max-width: 749px)');
    let i = 0;
    setInterval(() => {
      if (!mq.matches) { items.forEach(el => { el.style.display = ''; el.style.animation = ''; }); return; }
      items.forEach(el => { el.style.display = 'none'; });
      i = (i + 1) % items.length;
      const el = items[i];
      el.style.display = 'block';
      el.animate([{ opacity: 0, transform: 'translateY(100%)' }, { opacity: 1, transform: 'none' }], { duration: 450, easing: 'cubic-bezier(.2,.7,.2,1)' });
    }, 3500);
  }

  /* ---------- Clic sur un titre de carte : petite étincelle ---------- */
  function clickSparkles() {
    if (reduce) return;
    document.addEventListener('click', (e) => {
      const t = e.target.closest('.variant-picker__pill, .fx-badge, .social__link');
      if (t) burst(e.clientX, e.clientY, 8, 50);
    });
  }


  /* ======================= v3 – animations supplémentaires ======================= */
  function letters() {
    const w = $('.header__wordmark');
    if (!w || w.dataset.fx) return;
    w.dataset.fx = '1';
    w.setAttribute('aria-label', w.textContent);
    w.innerHTML = [...w.textContent].map((c, i) => `<span class="fx-letter" aria-hidden="true" style="--l:${i}">${c}</span>`).join('');
  }
  function friezes() {
    if (reduce) return;
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: 0.4 });
    $$('.frieze').forEach(f => { f.classList.add('rv'); io.observe(f); });
  }
  function spotlights() {
    if (reduce || !finePointer) return;
    const sel = '.trust__item, .features__item, .product-trust, .contact__form-wrap, .cart__aside, .accordion__item, .newsletter__inner';
    $$(sel).forEach(el => el.classList.add('fx-spot'));
    document.addEventListener('pointermove', (e) => {
      const el = e.target.closest('.fx-spot');
      if (!el) return;
      const r = el.getBoundingClientRect();
      el.style.setProperty('--mx', `${e.clientX - r.left}px`);
      el.style.setProperty('--my', `${e.clientY - r.top}px`);
    }, { passive: true });
  }
  function shootingStars() {
    if (reduce || !document.body.classList.contains('fx-stars')) return;
    const launch = () => {
      if (document.hidden) return;
      const s = document.createElement('span');
      s.className = 'fx-shoot';
      const x = innerWidth * (0.4 + Math.random() * 0.6), y = innerHeight * Math.random() * 0.5;
      s.style.left = `${x}px`; s.style.top = `${y}px`;
      document.body.appendChild(s);
      const dx = -(300 + Math.random() * 300), dy = 120 + Math.random() * 120, ang = Math.atan2(dy, dx) * 180 / Math.PI;
      s.animate([
        { transform: `translate(0,0) rotate(${ang}deg) scaleX(.2)`, opacity: 0 },
        { transform: `translate(${dx * 0.3}px, ${dy * 0.3}px) rotate(${ang}deg) scaleX(1)`, opacity: 1, offset: 0.3 },
        { transform: `translate(${dx}px, ${dy}px) rotate(${ang}deg) scaleX(.3)`, opacity: 0 }
      ], { duration: 1100, easing: 'ease-out' }).onfinish = () => s.remove();
    };
    setTimeout(function loop() { launch(); setTimeout(loop, 6000 + Math.random() * 7000); }, 3500);
  }
  function parallaxImages() {
    if (reduce) return;
    const items = $$('.split__media img, .vbreak__poster, .vbreak__video');
    if (!items.length) return;
    let ticking = false;
    const run = () => {
      ticking = false;
      items.forEach(img => {
        const r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        const p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
        img.style.translate = `0 ${(-p * 40).toFixed(1)}px`;
        img.style.scale = '1.08';
      });
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }
  function galleryZoom() {
    if (reduce || !finePointer) return;
    $$('.gallery__item').forEach(item => {
      const img = $('.gallery__img', item);
      if (!img) return;
      item.addEventListener('pointerenter', () => item.classList.add('is-zoom'));
      item.addEventListener('pointerleave', () => { item.classList.remove('is-zoom'); img.style.transformOrigin = ''; });
      item.addEventListener('pointermove', (e) => {
        const r = item.getBoundingClientRect();
        img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
      });
    });
  }

  function init() {
    if (!document.body.classList.contains('fx-on')) return;
    intro();
    reveal();
    counters();
    scrollFx();
    lazyVideos();
    pointerFx();
    cursorTrail();
    announcement();
    clickSparkles();
    letters();
    friezes();
    spotlights();
    shootingStars();
    parallaxImages();
    galleryZoom();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
